var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_25",
    "data-name": "Subtraction 25",
    d: "M15.5,31A15.5,15.5,0,0,1,9.467,1.218,15.5,15.5,0,0,1,21.533,29.782,15.4,15.4,0,0,1,15.5,31ZM6.038,21.55h0a10.937,10.937,0,0,0,5.995,1.757,11.458,11.458,0,0,0,3.909-.66,10.024,10.024,0,0,0,3.123-1.769A11.935,11.935,0,0,0,21.3,18.332a11.228,11.228,0,0,0,1.854-6.15c0-.187,0-.357-.011-.506A7.958,7.958,0,0,0,25.1,9.657a7.856,7.856,0,0,1-2.246.614,3.8,3.8,0,0,0,1.717-2.164,7.817,7.817,0,0,1-2.483.95,3.913,3.913,0,0,0-6.765,2.677,3.853,3.853,0,0,0,.1.89,10.919,10.919,0,0,1-4.494-1.2A11.183,11.183,0,0,1,7.366,8.537a3.916,3.916,0,0,0-.059,3.825,3.9,3.9,0,0,0,1.271,1.394,3.878,3.878,0,0,1-1.772-.489v.048a3.911,3.911,0,0,0,3.137,3.833,3.908,3.908,0,0,1-1.766.065,3.862,3.862,0,0,0,1.38,1.935,3.812,3.812,0,0,0,2.271.78A7.668,7.668,0,0,1,6.971,21.6,8.546,8.546,0,0,1,6.038,21.55Z",
    fill: "#4e4e4e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.7e5f6278abfeaa130b3c938cff6ade83.svg";
export { ForwardRef as ReactComponent };